import type React from "react";
import { Button, Grid, Badge } from "@material-ui/core";
import type { ResourceType } from "@/shared/work-orders-modals/components/work-order-resources/table-work-ordes-resoures";
import FolderIcon from "@material-ui/icons/Folder";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
	folderIcon: {
		color: "#FFC107",
	},
});

interface Props {
	params: any;
	setSelectedRow: Function;
	openResourceModal: (resource: ResourceType, rowData: any) => void;
}

export const WorkOrdersResourcesColumn: React.FC<Props> = ({
	params,
	setSelectedRow,
	openResourceModal,
}) => {
	const classes = useStyles();
	const handleClick = () => {
		setSelectedRow(params.data);
		openResourceModal("DRAWINGS", params.data);
	};

	const resourceCount = params.data?.ResourcesCount || 0;

	return (
		<Grid
			container
			spacing={1}
			style={{ justifyContent: "flex-end", minWidth: 30 }}
		>
			<Grid item xs={12} md={12}>
				<Button fullWidth style={{}} onClick={handleClick}>
					<Badge
						badgeContent={resourceCount}
						color="primary"
						style={{ transform: "scale(0.8)" }}
					>
						<FolderIcon
							className={classes.folderIcon}
							style={{ height: "auto", marginTop: "-2px" }}
						/>
					</Badge>
				</Button>
			</Grid>
		</Grid>
	);
};
